import { useState } from 'react';
import { BlogCommentEntity } from '../../../types';

interface UseCommentReplyStateProps {
  comment: BlogCommentEntity;
  onTriggerReply?: (targetComment: BlogCommentEntity) => void;
}

export function useCommentReplyState({ 
  comment, 
  onTriggerReply 
}: UseCommentReplyStateProps) {
  const [replyingToComment, setReplyingToComment] = useState<BlogCommentEntity | null>(null);

  // Determine if this is a top-level comment (level 1) or nested
  const isTopLevel = (comment.level || 1) === 1;

  // Function to handle reply to any comment in this thread
  const handleReplyToComment = (targetComment: BlogCommentEntity) => {
    if (isTopLevel) {
      setReplyingToComment(targetComment);
    } else if (onTriggerReply) {
      onTriggerReply(targetComment);
    }
  };

  const clearReplyState = () => {
    setReplyingToComment(null);
  };

  return {
    replyingToComment,
    isTopLevel,
    handleReplyToComment,
    clearReplyState
  };
}